export const wrapperStyles = { display: 'flex', flexDirection: 'column', gap: '16px' };
